import React, { useContext } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import LayoutSet from '../../components/layout/layout'
import { SpinnerContext } from '../../utils/shared.module'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../store/reduxInterface'
import { setSlideNav } from '../../store/commonSlice'
import Footer from '../../components/layout/footer'
// import FooterComponent from '../../contexts/footer.control'
// import HeaderComponent from '../../contexts/header.control'

const FeatureLayout: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const { isLoading } = useContext(SpinnerContext)
  const data = useSelector((state: State) => state.common.toggleSidebar)
  const hoverData = useSelector((state: State) => state.common.hoverSidebar)
  const minSideNav = useSelector((state: State) => state.common.slideNav)
  const excluding = ['/sales/sales-invoice']

  const withoutWrapperPages =
    location.pathname.includes('auth') ||
    excluding.includes(location.pathname) ||
    location.pathname.includes('user-invitation') ||
    location.pathname.includes('admin-invitation')
  return (
    <>
      <div>
        <div
          className={`main-wrapper ${isLoading == true ? 'isLoading' : ''} ${withoutWrapperPages ? 'login-body' : ''} ${minSideNav ? 'slide-nav' : ''} `}
        >
          {location.pathname.includes('admin-request-access') ||
          location.pathname.includes('user-request-access') ? (
            <Outlet />
          ) : (
            <>
              {/* <HeaderComponent /> */}
              {withoutWrapperPages ? <></> : <LayoutSet />}

              <div
                className={
                  withoutWrapperPages ? 'login-wrapper' : 'page-wrapper'
                }
              >
                <div
                  className={
                    location.pathname.includes('auth')
                      ? ''
                      : 'content container-fluid'
                  }
                >
                  <Outlet />
                </div>
                {/* <FooterComponent /> */}
                {/* <Footer /> */}
              </div>
            </>
          )}
        </div>
      </div>
      <div
        className={`sidebar-overlay ${minSideNav ? 'opened' : ''}`}
        onClick={() => dispatch(setSlideNav(!minSideNav))}
      ></div>
    </>
  )
}

export default FeatureLayout
